import { render, staticRenderFns } from "./EmailRegistrationForm.vue?vue&type=template&id=2eded450&scoped=true&"
import script from "./EmailRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./EmailRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailRegistrationForm.vue?vue&type=style&index=0&id=2eded450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eded450",
  null
  
)

export default component.exports